import React, { useState } from 'react';
import { ListDashItens } from '../../../../../../components/NovoSistema/ListDashItens';
import ModalImageDash from '../../../../../../components/NovoSistema/ModalImageDash';
import SubTitle from '../../../../../../components/NovoSistema/SubTitle';

export default function AnaliseReceita() {
  const [openModal, setOpenModal] = useState(false);
  const prefix = '/docs/controladoria/dashboard/BAF/';
  const nameImage = 'analise-receita';
  return (
    <main>
      <SubTitle text="ANÁLISE – Geração de Receita" />
      <ListDashItens>
        <li>Corte: AGO21.</li>
        <li>Descolamento superavitário médio do realizado de 11%.</li>
        <li>Tendência de crescimento da Receita em 6,3% no fechamento do FY.</li>
      </ListDashItens>
      <img
        onClick={() => setOpenModal(true)}
        src={`${prefix}${nameImage}.png`}
        alt={nameImage}
        style={{ width: '100%' }}
      />
      {openModal && <ModalImageDash close={setOpenModal} src={`${prefix}${nameImage}.png`} alt={nameImage} />}
    </main>
  );
}
